import { PAGE_TYPE_CONFIG } from '../../../../../utils/pageTypesConfig';

export const calculateLinkAddress = (pageType, path_hierarchy, position) => {
    const { pathPrefix } = PAGE_TYPE_CONFIG[pageType].breadcrumbs;

    let url = `/${pathPrefix}`;

    for (const [index, value] of path_hierarchy.entries()) {
        if (index > position) {
            break;
        }

        url += `/${value}`;
    }

    return url;
};
